import { capitalizeFirstLetter } from '@eneco/common/string';
import { DC_Domain_Models_Products_ProductType } from '@monorepo-types/dc';

export const getContractName = (productTypes: DC_Domain_Models_Products_ProductType[] | null | undefined) => {
  if (!productTypes) {
    return '';
  }

  return (
    productTypes.map(productType => capitalizeFirstLetter(getProductTypeTranslation(productType))).join(' & ') +
    ' contract'
  );
};

export const getProductTypeTranslation = (productType: DC_Domain_Models_Products_ProductType): string => {
  if (productType === 'electricity') {
    return 'stroom';
  } else if (productType === 'gas') {
    return 'gas';
  } else if (productType === 'warmth') {
    return 'warmte';
  }

  return productType;
};
